export const APP_VERSION = "v7.4.0.2";

export const FRONT_MATTER_TAG = "Career Climb Front Matter";

/* version up v7.4.0.2 */

export const PATHWAY_PERSONALITY_HIGHLY_RECOMMENDED = 0.75;
export const PATHWAY_PERSONALITY_RECOMMENDED = 0.5;
export const PATHWAY_PERSONALITY_NON_LOSE = 0.25;

export const CLEVER_LOGIN_METHOD = "Clever";
export const CLASSLINK_LOGIN_METHOD = "ClassLink";
export const BULK_LOGIN_METHOD = "LMS / SIS / Bulk CSV";
export const MANUAL_LOGIN_METHOD = "Manual";
export const NYC4D_LOGIN_METHOD = "nyc4d";
export const NYC4D_LOGIN_METHOD_DISPLAY = "NYC.ID";

// Login methods that can be edited by the district admin
export const EDIT_LOGIN_METHODS = [MANUAL_LOGIN_METHOD, BULK_LOGIN_METHOD];
